<template>
    <div class="w-full">
        <!-- INITIAL FORM -->
        <div class="w-full">
            <div v-for="(video, i) in media" :key="i">
                <div v-if="video.url && video.url.indexOf('http') === 0">
                    <div class="w-full mb-8">
                        <a class="button hover:border-grey-light m-2 h-10 py-3 px-6 text-sm border border-grey rounded text-black no-underline" @click="copyLink(video.url)">Copy Video URL<i class="fas fa-map-pin ml-2"></i></a>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="w-full h-full mb-5 px-2">
                            <iframe :src="video.url" class="w-full video-preview"></iframe>
                        </div>
                    </div>
                </div>
                <div class="ml-2" v-else>No video assets for this property</div>
                <hr class="border-b my-5" v-if="i < media.length - 1" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'asset-video',
  props: {
    media: Array
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['currentProperty', 'selectedOffice'])
  },
  created () {
  },
  methods: {
    copyLink (url) {
      const tempInput = document.createElement('input')
      tempInput.value = url
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
      alert('URL copied to clipboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-helper {
    background-color: rgba(255,255,255,.95);
    z-index: 2;
}
.video-preview {
    height: 520px;
}
</style>
